import wixData from 'wix-data';
import wixUsers from 'wix-users';
import {session} from 'wix-storage';

// -- SITE VERSION AND DEBUG FLAG --
session.setItem("siteVersion", "201204"+" "+"1045");
session.setItem("siteDebug", false)
let siteDebug = session.getItem("siteDebug");

// -- console hello
let siteVersion = session.getItem("siteVersion");
console.log("HELLO: TheWebMachine.net site version '"+siteVersion+"' loading...");
if (session.getItem("siteDebug") === "true") {console.log("DEBUG=true")}

// -- START $w.onReady()!
$w.onReady(function () {

// -- update siteVersion at bottom of page
	$w("#textSiteVer").text = siteVersion;

});
// -- END $w.onReady()!


// -- unhide siteVersion at bottom of page when clicked
export function textSiteVer_click(event) {
	let value = $w("#textSiteVer").text;
	$w("#textSiteVer").html = "<font color='#F7714C'><b><center>"+value+"</center></b></font>";
}


